import axios from "axios";

export const state = {
    insurancepackages: [],
};

export const getters = {
    insurancepackages: state => state.insurancepackages,
};

export const mutations = {
    setPackages(state, newValue) {
        state.insurancepackages = newValue
    },
};

export const actions = {
    fetchInsurancePackages({ commit }) {
        axios.get('/insurancepackages').then(res => {
            commit('setPackages', res.data.packages)
        })
    },
};
